import * as React from "react";
import { BarChart3, ShieldCheck, Zap } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const features = [{
  title: "Enfoque Personalizado",
  description: "Diseño estrategias únicas adaptadas a tu ritmo y objetivos específicos, garantizando un proceso de transformación real y profundo.",
  icon: Zap
}, {
  title: "Metodología Científica",
  description: "Utilizo herramientas de coaching de vanguardia con base científica para asegurar que cada paso que damos tenga un propósito claro.",
  icon: ShieldCheck
}, {
  title: "Resultados de Alto Impacto",
  description: "Nos enfocamos en metas medibles que te permitan observar tu progreso constante y alcanzar el éxito profesional que buscas.",
  icon: BarChart3
}];
export default function FeatureGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="30210" id="diferenciación" className="py-20 bg-dark-background">
      <div className="container mx-auto px-4">
        <div ref={ref} className={cn("grid grid-cols-1 md:grid-cols-3 gap-6 transition-opacity duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          {features.map((feature, i) => <Card key={i} data-index={i} className="group relative bg-dark-background border-transparent rounded-lg shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-medium overflow-hidden">
              {}
              <div className="absolute inset-0 rounded-lg border border-transparent group-hover:border-transparent bg-gradient-to-r from-accent to-primary opacity-0 group-hover:opacity-10 pointer-events-none [mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] [-webkit-mask-composite:xor] [mask-composite:exclude] p-[1px] -z-10 transition-opacity duration-300" />

              <CardHeader className="pb-4">
                <div className="mb-6 relative inline-flex items-center justify-center w-12 h-12">
                  {}
                  <div className="absolute inset-0 bg-accent/20 blur-xl rounded-full opacity-40" />
                  <feature.icon className="w-8 h-8 text-accent relative z-10" strokeWidth={1.5} />
                </div>
                <CardTitle className="font-display font-bold text-[22px] text-foreground-dark">
                  {feature.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="font-sans text-[15px] text-foreground-dark/80 leading-relaxed">
                  {feature.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}